import React, { useState, useRef, useEffect, useCallback } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import FridgeArea from './components/FridgeArea';
import CandidateArea from './components/CandidateArea';
import './App.css';
import ReactMarkdown from 'react-markdown';

function App() {
  const [fridgeItems, setFridgeItems] = useState([
    { id: '1', name: '牛乳', type: 'dairy' },
    { id: '2', name: '卵', type: 'protein' },
  ]);

  const [candidateItems, setCandidateItems] = useState([
    { id: '3', name: 'トマト', type: 'vegetable' },
    { id: '4', name: 'レタス', type: 'vegetable' },
    { id: '5', name: 'キャベツ', type: 'vegetable' },
    { id: '6', name: '鶏肉', type: 'meat' },
    { id: '7', name: '豚肉', type: 'meat' },
    { id: '8', name: '魚', type: 'fish' },
    { id: '9', name: '豆腐', type: 'soy' },
    { id: '10', name: 'ご飯', type: 'grain' },
    { id: '11', name: 'パスタ', type: 'grain' },
    { id: '12', name: 'りんご', type: 'fruit' },
    { id: '13', name: 'バナナ', type: 'fruit' },
    { id: '14', name: 'オレンジ', type: 'fruit' },
    { id: '15', name: 'じゃがいも', type: 'vegetable' },
    { id: '16', name: '玉ねぎ', type: 'vegetable' },
    { id: '17', name: 'にんじん', type: 'vegetable' },
    { id: '18', name: 'ピーマン', type: 'vegetable' },
    { id: '19', name: 'きゅうり', type: 'vegetable' },
    { id: '20', name: 'ブロッコリー', type: 'vegetable' },
  ]);

  const [isRecepiPanelOpen, setIsRecepiPanelOpen] = useState(false);
  const [SuggestRecipeText, setSuggestRecipeText] = useState(null);
  const [fridgeInputValue, setFridgeInputValue] = useState("");
  const [candidateInputValue, setCandidateInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [recipePanelWidth, setRecipePanelWidth] = useState(window.innerWidth * 0.5);
  const isResizing = useRef(false);
  const initialMouseX = useRef(0);
  const initialPanelWidth = useRef(0);

  // --- 提案オプション関連のStateを追加 ---
  const [suggestionOptionsOpen, setSuggestionOptionsOpen] = useState(false);
  const [suggestionMode, setSuggestionMode] = useState('normal'); // 'normal' or 'creative'
  const [ingredientUsage, setIngredientUsage] = useState('all'); // 'all' or 'some'
  const [recipeType, setRecipeType] = useState(''); // 'main', 'side', 'dessert', etc.
  const [allowExternalIngredients, setAllowExternalIngredients] = useState(false); 
  const prev_recipes = useRef([]) 

  const handleMoveStickyNote = (id, targetAreaType) => {
    let movedItem = null;

    setFridgeItems((prev) => {
      const itemIndex = prev.findIndex((item) => item.id === id);
      if (itemIndex > -1 && targetAreaType === 'candidate') {
        movedItem = prev[itemIndex];
        return prev.filter((item) => item.id !== id);
      }
      return prev;
    });

    setCandidateItems((prev) => {
      const itemIndex = prev.findIndex((item) => item.id === id);
      if (itemIndex > -1 && targetAreaType === 'fridge') {
        movedItem = prev[itemIndex];
        return prev.filter((item) => item.id !== id);
      }
      return prev;
    });

    if (movedItem) {
      if (targetAreaType === 'fridge') {
        setFridgeItems((prev) => [...prev, movedItem]);
      } else if (targetAreaType === 'candidate') {
        setCandidateItems((prev) => [...prev, movedItem]);
      }
    }
  };

  const handleAddFridgeIngredient = () => {
    if (fridgeInputValue.trim() === '') {
      return;
    }
    setFridgeItems((prev) => [...prev, { id: Date.now().toString(), name: fridgeInputValue.trim(), type: 'other' }]);
    setFridgeInputValue("");
  };

  const handleAddCandidateIngredient = () => {
    if (candidateInputValue.trim() === '') {
      return;
    }
    setCandidateItems((prev) => [...prev, { id: Date.now().toString(), name: candidateInputValue.trim(), type: 'other' }]);
    setCandidateInputValue("");
  };

  // --- API呼び出し関数を更新 ---
  const handleSuggestFromFridgeContents = async (items, prev_recipe=null) => {
    setIsLoading(true);
    setSuggestionOptionsOpen(false); // 提案開始時にオプションを閉じる
    try {
      const itemNames = items.map((item) => item.name);

      // それ以前のレシピがある場合
      if (prev_recipe !== null){
        const match = prev_recipe.match(/^#+\s+(.*)/m);
        const recipe_title = match ? match[1] : "";
        prev_recipes.current.push(recipe_title);
      }
      
      console.log("レシピ:",prev_recipes.current);

      // modeパラメータに選択されたオプションを追加
      const response = await fetch('/.netlify/functions/SuggestRecipe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          ingredients: itemNames, 
          mode: suggestionMode, 
          usage: ingredientUsage, 
          type: recipeType, 
          allowExternalIngredients: allowExternalIngredients ,
          prev_recipes: prev_recipes!==null ? prev_recipes.current : []
        }),
      });

      const data = await response.json();
      const recipe = data.recipeText;

      setSuggestRecipeText(recipe);
      setIsRecepiPanelOpen(true);
    } catch (error) {
      console.error("Error fetching recipe:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleCloseRecipePanel = () => {
    setIsRecepiPanelOpen(false);
  }

  const handleMouseMove = useCallback((e) => {
    if (!isResizing.current) return;

    const dx = initialMouseX.current - e.clientX;
    let newWidth = initialPanelWidth.current + dx;

    const minWidth = 200;
    const maxWidth = window.innerWidth;
    if (newWidth < minWidth) newWidth = minWidth;
    if (newWidth > maxWidth) newWidth = maxWidth;

    setRecipePanelWidth(newWidth);
  }, []);

  const handleMouseUp = useCallback(() => {
    isResizing.current = false;
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
    document.body.style.cursor = 'default';
    document.body.style.userSelect = 'auto';
  }, [handleMouseMove]);

  const handleMouseDown = useCallback((e) => {
    isResizing.current = true;
    initialMouseX.current = e.clientX;
    initialPanelWidth.current = recipePanelWidth;
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.body.style.cursor = 'ew-resize';
    document.body.style.userSelect = 'none';
  }, [recipePanelWidth, handleMouseMove, handleMouseUp]);

  useEffect(() => {
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [handleMouseMove, handleMouseUp]);

  // オプションパネル外をクリックで閉じる処理
  const optionsRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setSuggestionOptionsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [optionsRef]);


  return (
    <DndProvider backend={HTML5Backend}>
      <div className="App">
        <h1>レシピ提案</h1>

        <div className="area-section">
          <div className="fridge-area-wrapper">
            <FridgeArea items={fridgeItems} onMove={handleMoveStickyNote} />
            <div className="add-item-control">
              <input
                type="text"
                placeholder="冷蔵庫に追加"
                value={fridgeInputValue}
                onChange={(e) => setFridgeInputValue(e.target.value)}
                onKeyPress={(e) => { if (e.key === 'Enter') handleAddFridgeIngredient(); }}
              />
              <button onClick={handleAddFridgeIngredient}>追加</button>
            </div>
          </div>

          <div className="candidate-area-wrapper">
            <CandidateArea items={candidateItems} onMove={handleMoveStickyNote} />
            <div className="add-item-control">
              <input
                type="text"
                placeholder="その他に追加"
                value={candidateInputValue}
                onChange={(e) => setCandidateInputValue(e.target.value)}
                onKeyPress={(e) => { if (e.key === 'Enter') handleAddCandidateIngredient(); }}
              />
              <button onClick={handleAddCandidateIngredient}>追加</button>
            </div>
          </div>
        </div>

        <div className="suggestion-control-container"> {/* 新しいコンテナでボタンとオプションをまとめる */}
          <button
            onClick={() => { prev_recipes.current = [];handleSuggestFromFridgeContents(fridgeItems) }}
            className="action-button"
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="spinner"></div>
            ) : (
              '提案'
            )}
          </button>
          <div className="options-button-container" ref={optionsRef}>
            <button
              onClick={() =>  setSuggestionOptionsOpen(!suggestionOptionsOpen)}
              className="options-toggle-button"
              aria-expanded={suggestionOptionsOpen}
            >
              ▼
            </button>
            {suggestionOptionsOpen && (
              <div className="suggestion-options-dropdown">
                {/* 提案モード */}
                <div className="option-group">
                  <h3>提案モード</h3>
                  <label>
                    <input
                      type="radio"
                      value="normal"
                      checked={suggestionMode === 'normal'}
                      onChange={() => setSuggestionMode('normal')}
                    />
                    普通の提案
                  </label>
                  <label>
                    <input
                      type="radio"
                      value="creative"
                      checked={suggestionMode === 'creative'}
                      onChange={() => setSuggestionMode('creative')}
                    />
                    クリエイティブな提案
                  </label>
                </div>

                {/* 冷蔵庫内にない材料を使うかどうか*/}
                <div className="option-group">
                  <h3>冷蔵庫にない材料</h3>
                  <label>
                    <input
                      type="radio"
                      value="false" // false: 冷蔵庫内のみ
                      checked={!allowExternalIngredients}
                      onChange={() => setAllowExternalIngredients(false)}
                    />
                    冷蔵庫の材料のみ
                  </label>
                  <label>
                    <input
                      type="radio"
                      value="true" // true: 冷蔵庫にない材料も可
                      checked={allowExternalIngredients}
                      onChange={() => setAllowExternalIngredients(true)}
                    />
                    冷蔵庫にない材料も使用
                  </label>
                </div>


                {/* 材料の使用方法 */}
                <div className="option-group">
                  <h3>材料の使用</h3>
                  <label>
                    <input
                      type="radio"
                      value="all"
                      checked={ingredientUsage === 'all'}
                      onChange={() => setIngredientUsage('all')}
                    />
                    すべての材料を使う
                  </label>
                  <label>
                    <input
                      type="radio"
                      value="some"
                      checked={ingredientUsage === 'some'}
                      onChange={() => setIngredientUsage('some')}
                    />
                    一部を使う
                  </label>
                </div>

                {/* 提案タイプ */}
                <div className="option-group">
                  <h3>提案タイプ</h3>
                  <select
                    value={recipeType}
                    onChange={(e) => setRecipeType(e.target.value)}
                  >
                    <option value="">指定なし</option>
                    <option value="main">主菜</option>
                    <option value="side">副菜</option>
                    <option value="soup">汁物</option>
                    <option value="dessert">デザート</option>
                    <option value="drink">飲み物</option>
                  </select>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* レシピ表示パネル */}
        <div
          className={`recipe-panel ${isRecepiPanelOpen ? 'open' : ''}`}
          style={{
            width: window.innerWidth <= 768 ? '100%' : `${recipePanelWidth}px`
          }}
        >
          {window.innerWidth > 768 && (
            <div className="resize-handle" onMouseDown={handleMouseDown}></div>
          )}

          <div className="recipe-panel-header">
            <h2>提案されたレシピ</h2>
            <button onClick={handleCloseRecipePanel} className="close-button">×</button>
          </div>
          <div className="recipe-panel-content">
            {isLoading && (
              <div className="recipe-loading-spinner">
                <div className="spinner"></div>
                <p>レシピを読み込み中...</p>
              </div>
            )}
            {!isLoading && SuggestRecipeText && (
              <>
                <ReactMarkdown className="recipe-text">
                  {SuggestRecipeText}
                </ReactMarkdown>
                <div className="resuggest-button-container">
                  <button
                    onClick={() => handleSuggestFromFridgeContents(fridgeItems,SuggestRecipeText)}
                    className="resuggest-button"
                    disabled={isLoading}
                  >
                    {isLoading ? '提案中...' : 'もう一度別の料理を提案'}
                  </button>
                </div>
              </>
            )}
            {!isLoading && !SuggestRecipeText && (
              <p>レシピがありません。</p>
            )}
          </div>
        </div>

      </div>
    </DndProvider>
  );
}

export default App;